'use client'
import { styled } from '../config'

function Svg(props) {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g id="lock-closed">
        <path
          id="Vector"
          d="M7.90625 3.75H7.5625V2.1875C7.5625 1.69022 7.3452 1.21331 6.95841 0.861675C6.57161 0.510044 6.04701 0.3125 5.5 0.3125C4.95299 0.3125 4.42839 0.510044 4.04159 0.861675C3.6548 1.21331 3.4375 1.69022 3.4375 2.1875V3.75H3.09375C2.7292 3.75036 2.37969 3.88217 2.12192 4.11652C1.86414 4.35086 1.71915 4.66859 1.71875 5V8.4375C1.71915 8.76891 1.86414 9.08664 2.12192 9.32098C2.37969 9.55533 2.7292 9.68714 3.09375 9.6875H7.90625C8.2708 9.68714 8.62031 9.55533 8.87808 9.32098C9.13586 9.08664 9.28085 8.76891 9.28125 8.4375V5C9.28085 4.66859 9.13586 4.35086 8.87808 4.11652C8.62031 3.88217 8.2708 3.75036 7.90625 3.75ZM6.875 3.75H4.125V2.1875C4.125 1.85598 4.26987 1.53804 4.52773 1.30362C4.78559 1.0692 5.13533 0.9375 5.5 0.9375C5.86467 0.9375 6.21441 1.0692 6.47227 1.30362C6.73013 1.53804 6.875 1.85598 6.875 2.1875V3.75Z"
          fill="#parent"
        />
      </g>
    </svg>
  )
}

export const Lock = styled(Svg)
